<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          INVESTMENT TYPE
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Investment Type List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              @keyup="searching()"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              id="add-division"
              @click="create()"
              color="secondblue"
              class="white--text"
            >
              <v-icon left dark>add</v-icon>
              Add new type
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="investmentTypes"
          :search="search"
          :loading="loading"
          :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.name }}</td>
            </tr>
          </template>
          <template v-slot:item.created_by="{ item }">
            {{
              item.logCreate
                ? item.logCreate.length > 0
                  ? item.logCreate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.updated_by="{ item }">
            {{
              item.logUpdate
                ? item.logUpdate.length > 0
                  ? item.logUpdate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              :id="'btn-edit' + item.id"
              @click="edit(item)"
              icon
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-delete' + item.id"
              @click="deleteItem(item.id)"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="showDialog" id="isCreate" persistent max-width="450px">
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-title class="primary white--text">
              <span class="pa-0"
                >{{ isCreate ? 'Create' : 'Edit' }} Investment Type</span
              >
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-0 pb-2">
                    <ValidationProvider
                      name="Name"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label>Name</label>
                      <v-text-field
                        single-line
                        outlined
                        dense
                        placeholder="Name"
                        v-model="itemDetail.name"
                        required
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-6 px-6">
              <v-spacer></v-spacer>
              <v-btn color="#bd1e19" dark @click="closeDialog()">
                Close
              </v-btn>
              <v-btn color="primary" dark type="submit">
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      search: '',
      isSearch: false,
      totalItems: 0,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      descending: true,
      sort: '',
      options: {
        itemsPerPage: 5
      },
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Investment Type List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'Created By',
          value: 'created_by'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Updated By',
          value: 'updated_by'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      investmentTypes: [],
      showDialog: false,
      isCreate: false,
      itemDetail: {
        name: ''
      },
      timeout: null
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searching() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      const search = {
        name: this.search
      };
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      this.$store
        .dispatch('investmentType/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data) {
            this.investmentTypes = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', 'gagal', 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    create() {
      this.showDialog = true;
      this.isCreate = true;
      this.itemDetail.name = '';
    },
    edit(item) {
      this.id = item.id;
      this.showDialog = true;
      this.isEdit = true;
      this.itemDetail = this.copy(item);
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.isEdit) {
          this.$store
            .dispatch('investmentType/update', {
              id: this.id,
              params: this.itemDetail
            })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.closeDialog();
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log('error', err);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          const params = {
            name: this.itemDetail.name,
            alias: this.itemDetail.name
              .toLowerCase()
              .split(' ')
              .join('_')
          };
          this.$store
            .dispatch('investmentType/create', params)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.closeDialog();
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log('error', err);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this Investment Type!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.$store.dispatch('investmentType/delete', id).then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Deleted!', data.message.text_en, 'success');
            this.clear();
            this.getData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your Investment Type data has been undeleted',
            'error'
          );
        }
      });
    },
    closeDialog() {
      this.showDialog = false;
      this.isCreate = false;
      this.isEdit = false;
      this.clear();
    },
    async clear() {
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    }
  }
};
</script>
